/*
 * Copyright (c) 2025, King Living
 * PDP layout constants shared by ProductView and desktop configuration gallery.
 */

/** Desktop `ConfigurationSelector` panel width (px). */
export const PDP_DESKTOP_CONFIG_PANEL_WIDTH_PX = 480;
